var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 9.16634C2.69873 9.16634 0.833313 7.30092 0.833313 4.99967C0.833313 2.69842 2.69873 0.833008 4.99998 0.833008C7.30123 0.833008 9.16665 2.69842 9.16665 4.99967C9.16665 7.30092 7.30123 9.16634 4.99998 9.16634ZM4.99998 4.41051L3.82165 3.23176L3.23206 3.82134L4.41081 4.99967L3.23206 6.17801L3.82165 6.76759L4.99998 5.58884L6.17831 6.76759L6.7679 6.17801L5.58915 4.99967L6.7679 3.82134L6.17831 3.23176L4.99998 4.41051Z",
    fill: "#D9E5F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveService);
export default __webpack_public_path__ + "static/media/remove-service.6b92090e28c8277b6224371e5c98135a.svg";
export { ForwardRef as ReactComponent };